import { TextButton } from '@joor/design-system'

import { Body, Container, Header } from './Common.ui'

export function JoorPayDisabledOverlay({ onLinkClick }: Props) {
  return (
    <Container>
      <Header>{CONTENT.HEADER_TEXT}</Header>
      <Body>
        {CONTENT.BODY_TEXT_1}{' '}
        {<TextButton onClick={onLinkClick}>{CONTENT.LINK_TEXT}</TextButton>}{' '}
        {CONTENT.BODY_TEXT_2}
      </Body>
    </Container>
  )
}

type Props = {
  onLinkClick: () => void
}

export const CONTENT = {
  HEADER_TEXT: 'JOOR Pay not enabled',
  BODY_TEXT_1: "You're not signed up for JOOR Pay.",
  LINK_TEXT: 'Learn more',
  BODY_TEXT_2:
    'about JOOR Pay and apply today to support multiple payment types across 130+ geographies on all your orders.',
}
